import { Box, SxProps, Typography } from '@mui/material';
import { ReactElement } from 'react';

export const CAMPAIGN_CREATION_WIDTH_FIELD = '50%';
const containerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
  maxWidth: '600px'
};

const childrenSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '40px'
};

type Props = {
  title: string;
  subTitle?: string;
  children: ReactElement;
};

export const CampaignCreationSection: React.FC<Props> = ({
  title,
  subTitle,
  children
}) => {
  return (
    <Box sx={containerSx}>
      <Box>
        <Typography variant="sectionTitle">{title}</Typography>
        <Typography>{subTitle}</Typography>
      </Box>
      <Box sx={childrenSx}>{children}</Box>
    </Box>
  );
};
